<template>
  <ComponentCard title="Picture with points" icon="solar:map-point-linear">
    <BlockField :model-value="attrs.title" placeholder="Title (optional)" :read-only="readOnly" @update:model-value="set({ title: $event })" />
    <div v-if="attrs.image" class="relative mx-auto aspect-[3/4] w-full max-w-[320px] cursor-crosshair overflow-hidden rounded-2xl" @click="place">
      <img :src="attrs.image" alt="" class="absolute inset-0 h-full w-full object-cover" draggable="false">
      <span v-for="(item, i) in attrs.items" :key="i" class="absolute flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white text-xs font-bold shadow" :class="moving === i ? 'bg-[#c9a961] text-white' : 'bg-white text-[#1c4848]'" :style="{ left: `${item.x}%`, top: `${item.y}%` }">{{ i + 1 }}</span>
    </div>
    <p v-if="!readOnly && attrs.image" class="text-center text-xs text-[#1c4848]/55">{{ moving === null ? 'Click the picture to add a point.' : `Click where point ${moving + 1} should go.` }}</p>
    <ImagePicker v-if="!readOnly" :context="context" :has-image="Boolean(attrs.image)" compact @picked="set({ image: $event })" />
    <div v-for="(item, i) in attrs.items" :key="i" class="rounded-xl bg-[#1c4848]/[0.03] p-2">
      <BlockField :model-value="item.title" :placeholder="`Point ${i + 1}`" :read-only="readOnly" input-class="text-sm font-bold text-[#1c4848]" @update:model-value="list.patch(i, { title: $event })" />
      <BlockField :model-value="item.text" placeholder="What readers see when they tap it" :read-only="readOnly" input-class="text-sm text-[#1c4848]/80" @update:model-value="list.patch(i, { text: $event })" />
      <div v-if="!readOnly" class="flex items-center gap-2 px-2">
        <button type="button" class="min-h-9 rounded-lg bg-[#1c4848]/5 px-3 text-xs font-bold text-[#1c4848]" @click="moving = moving === i ? null : i">{{ moving === i ? 'Cancel' : 'Move' }}</button>
        <RowActions :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="remove(i)" />
      </div>
    </div>
  </ComponentCard>
</template>

<script setup>
import { ref } from 'vue';
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
const moving = ref(null);

function place(event) {
  if (props.readOnly) return;
  const box = event.currentTarget.getBoundingClientRect();
  const spot = { x: String(Math.round(((event.clientX - box.left) / box.width) * 100)), y: String(Math.round(((event.clientY - box.top) / box.height) * 100)) };
  if (moving.value === null) {
    list.add({ ...spot, title: '', text: '' });
  } else {
    list.patch(moving.value, spot);
    moving.value = null;
  }
}

function remove(i) {
  moving.value = null;
  list.remove(i);
}
</script>
